export default {
  inserted(el, binding) {
    el.addEventListener('click', function handler(e) {
      // 阻止事件冒泡和默认行为
      e.preventDefault();
      e.stopPropagation();

      if (el.style.pointerEvents !== 'none') {
        el.style.pointerEvents = 'none';

        setTimeout(() => {
          el.style.pointerEvents = 'auto';
        }, binding.value || 1600)
      }
    })
  }
}